document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('.header__nav .header__link');

    navLinks.forEach(link => {
        link.addEventListener('mouseenter', function(e) {
            const rect = this.getBoundingClientRect();
            // Calculate mouse position relative to the element
            const mouseX = e.clientX - rect.left;
            
            // If mouse is on left half, it entered from left. Otherwise from right.
            const originX = mouseX < rect.width / 2 ? 'left' : 'right';
            
            this.style.setProperty('--hover-origin', `${originX} center`);
        });

        link.addEventListener('mouseleave', function(e) {
            const rect = this.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;
            
            // If mouse exits left, we want it to shrink towards the right (so origin right)
            // Wait, if origin is left, scaleX(0) makes it shrink towards left! This is correct.
            const originX = mouseX < rect.width / 2 ? 'left' : 'right';
            
            this.style.setProperty('--hover-origin', `${originX} center`);
        });
    });
});
